import React from 'react'

import { useSelector } from 'react-redux';


import GoogleMapReact from 'google-map-react'
//import PropTypes from 'prop-types';
//import LocationPin from 'components/LocationPin/LocationPin';
//import Marker from 'components/Marker/Marker';
import './map.css'
import Marker from 'components/Marker/Marker';




/* function handleMarkerClick(text){
  console.log('Click', text)
} */
function handleMarkerClick(text){
  console.log('Click', text)
}


export default function MapPlantacion () {
  const {language, plantaciones, allPlantaciones, indexPlantacion } = useSelector( state => state.data);




  const handleApiLoaded = (map, maps) => {
    map.setMapTypeId('satellite');
    
     if (allPlantaciones) {
        console.log("Allselected");
        plantaciones.map((plantacion) => {
          let poligonCoords = plantacion.coordenadas;
  
          var poligonPlantacion = new maps.Polygon({
            paths: poligonCoords,
            strokeColor: '#ff0005',
            strokeOpacity: 0.85,
            strokeWeight: 1,
            fillColor: plantacion.color,
            fillOpacity: 0.6
          });
          poligonPlantacion.setMap(map);
        })
      
      } else {
      
        const poligonCoords = plantaciones[indexPlantacion].coordenadas;
        
        //console.log("plantacion " + indexPlantacion + " coordnenadas: " + poligonCoords);

        var poligonPlantacion = new maps.Polygon({
          paths: poligonCoords,
          strokeColor: '#ff0005',
          strokeOpacity: 0.85,
          strokeWeight: 1,
          fillColor: plantaciones[indexPlantacion].color,
          fillOpacity: 0.6
        });



        poligonPlantacion.setMap(map);
      }

      
    

    
  }



  return (

        
      
        <GoogleMapReact
          
          bootstrapURLKeys={{ 
            key: process.env.REACT_APP_GOOGLE_KEY,
            language:{language},
          }}


          defaultCenter={plantaciones[0].ubicacion}
          defaultZoom={plantaciones[0].zoom}
          options={(maps) => ({
            zoomControl: true,
            controlSize: 20,
            zoomControlOptions: {
              position: maps.ControlPosition.RIGHT_BOTTOM
            }
          })}
          key={`${indexPlantacion}`}
          
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          
          
          yesIWantToUseGoogleMapApiInternals
        >
         
         {
          (allPlantaciones)? (
            plantaciones.map((plantacion) => (
                plantacion.sensores.map((sensor) => (
                  <Marker  
                      key={sensor.name}
                      text={sensor.name}
                      lat={sensor.lat}
                      lng={sensor.long}
                      onClick={handleMarkerClick}
                      toolTipObj={sensor}
                  />
                ))
            ))
            )
            :
            (
              
                plantaciones[indexPlantacion].sensores.map((sensor) => (
                  <Marker  
                      key={sensor.name}
                      text={sensor.name}
                      lat={sensor.lat}
                      lng={sensor.long}
                      onClick={handleMarkerClick}
                      toolTipObj={sensor}
                  />
                ))
            
            )
          
          }


        </GoogleMapReact>
        
        
      
      
  )
}
  
  

